import locale from "localization/en";

export const expenseLogsColumn = [
  { key: "expenseId", text: locale.expenseId },
  {
    key: "shiftDate",
    text: locale.shiftDateAndTime,
    style: {
      width: "auto",
      minWidth: "200px",
    },
  },
  {
    key: "expenseDateAndTime",
    text: locale.expenseDateAndTime,
    style: {
      width: "auto",
      minWidth: "200px",
    },
  },
  { key: "type", text: locale.typeOfExpense },
  { key: "amount", text: locale.amount, width: "250px" },
  { key: "remarks", text: locale.remarks },
  { key: "viewAttachment", text: locale.viewAttachment },
  { key: "action", text: locale.action },
];
